export const newProjects2 = {
  "Customer Success": [
    "Projects follow-up and client check-ins",
    "QBR/ABR",
    "Content sharing and product updates",
    "Internal coordination",
    "Client Certification activities",
    "Workshops",
    "Training",
    "EmotionsAI - CS",
    "Search & Reco - CS",
    "Basic technical support (new service offers only)",
    "Gargarisation lunch",
  ],
  "Professional Services": [
    "Ask-TSE",
    "Campaign briefs",
    "Campaign feasibility analysis",
    // "Campaign development",
    "Campaign QA",
    "Campaign analysis",
    "Custom Code",
    "Search & Reco - Technical",
    "Third-party integration",
    "Campaign implementation",
    "Native integration support",
    "Tag integration support",
    "EmotionsAI mapping",
    "Reco/algo implementation",
    "Campaign documentation",
    "Campaign analysis",
  ],
  Onboarding: [
    "Technical implementation",
    "Tools and processes setup",
    "JumpStart (prep & delivery)",
    "Quick-wins and first use-case implementation",
    "Projects follow-up and client check-ins",
  ],
  MUVs: ["MUVs"],
  Support: ["Basic support on the platform"],
  "Internal Strategy": [
    "Action plan & processes",
    "Client Handover (new comers)",
    "Side & Strategic projects",
    "Strategy - other activities",
  ],
  "Knowledge base": [
    "Internal Trainings/BYS/Product updates",
    "CRO Academy - content & gtm",
    "Certification & Documentation - creation/maintenance",
    "External Trainings/Certification/Conference/Webinar",
  ],
  Debug: ["Debug"],
  "Product activities": ["Internal QA and feedback & EA process"],
  "Marketing activities": ["Events, webinars, use-cases, etc."],
  "Sales activities": ["Pre-sales activities"],
  "KAM activities": ["KAM activities"],
  "Admin & HR": [
    "Reviews and other management meetings",
    "Recruitment",
    "Spendesk, Travel arrangements, IT (laptop, proxy, etc.)",
    "Internal tools - update and maintenance",
    "Other",
  ],
  Partners: [
    "JumpStart (prep & delivery)",
    "Specific workshop/meeting",
    "CRO Academy - delivery",
    "Campaign feasibility analysis",
    "Campaign briefs",
    "Campaign development",
    "Campaign QA",
    "Campaign analysis",
  ],
  "Day Off": ["Full day", "Half day"],
  "Balance Recovery": ["Balance recovery"],
};

// export const scopes = ['Client-side', 'Flagship', '  ', 'EmotionsAI','n/a']
// export const scopes = [
//   "Web Exp & Perso",
//   "FE&R",
//   "EmotionsAI",
//   "Potions",
//   "Epoq",
//   "n/a",
// ];

export const scopes = [
  "WE&P",
  "FE&R",
  "EmotionsAI",
  "R&M",
  "Epoq",
  "N/A"
]

export const hours = [0, 1, 2, 3, 4, 5, 8];

export const minutes = [0, 15, 30, 45];

export const periods = [
  {
    name: "This Week",
    value: "This Week",
  },
  {
    name: "This Month",
    value: "This Month",
  },
  {
    name: "This Quarter",
    value: "This Quarter",
  },
  {
    name: "This Year",
    value: "This Year",
  },
  {
    name: "Last Week",
    value: "Last Week",
  },
  {
    name: "Last Month",
    value: "Last Month",
  },
  {
    name: "Last Quarter",
    value: "Last Quarter",
  },
  {
    name: "Last Year",
    value: "Last Year",
  },
];

export const BAsSpecificTasks = [
  "Campaign implementation",
  "Native integration support",
  "Tag integration support",
  "EmotionsAI mapping",
  "Reco/algo implementation",
  "Campaign documentation",
  "Campaign analysis",
]

export const breakdowns = [
  {
    name: "Week",
    value: "Week",
  },
  {
    name: "Month",
    value: "Month",
  },
  {
    name: "Quarter",
    value: "Quarter",
  },
];

export const billables = [
  {
    name: "Client Billable",
    value: "Client Billable",
  },
  {
    name: "Client Not Billable",
    value: "Client Not Billable",
  },
  {
    name: "Internal",
    value: "Internal",
  },
  {
    name: "All",
    value: "All",
  },
];

export const teamReportTypes = [
  {
    name: "Project report",
    value: "project",
  },
  {
    name: "Billable report",
    value: "billable",
  },
];
export const teamMembersReportTypes = [
  {
    name: "Project report",
    value: "project",
  },
  {
    name: "Billable report",
    value: "billable",
  },
];

export const clientReportTypes = [
  {
    name: "Project report",
    value: "project",
  },
  {
    name: "Billable report",
    value: "billable",
  },
  {
    name: "Product report",
    value: "product",
  },
];

export const personalReportTypes = [
  {
    name: "Project report",
    value: "project",
  },
  {
    name: "Billable report",
    value: "billable",
  },
  {
    name: "Client report",
    value: "client",
  },
];
